module.exports = __webpack_public_path__ + "media/images/logo_cas_full-67de04b2.svg";